import { TaskView } from '@/modules/tasks/models/TaskViewBody'

import { Task } from '../../../../therapist/pages/tasks/types/Task'
import { axios, Response } from '../index'

export type TaskResponse = {
  id: string
  title: string
  description: string
  taskStatus: string
  personaInfoSummaries: PersonaInfoSummary[]
  taskComments: TaskComment[]
  checklistsResponses: ChecklistsResponse[]
  taskTags: TaskTag[]
  taskFiles: TaskFile[]
  taskView: TaskView[]
  startDate: string
  endDate: string
  createdAt: string
}

type PersonaInfoSummary = {
  userId: string
  username: string
  avatarUrl: string
}

type TaskComment = {
  taskCommentId: string
  taskId: string
  content: string
  creator: Creator
  createdAt: string
}

type Creator = {
  userId: string
  username: string
  avatarUrl: string
}

export type ChecklistsResponse = {
  id: string
  taskId: string
  title: string
  checklistItems: ChecklistItem[]
}

export type ChecklistItem = {
  id: string
  title: string
  checklistId: string
  responsibleForTheDemandId?: ResponsibleForTheDemandId
  isDone: boolean
}

type ResponsibleForTheDemandId = {
  userId: string
  username: string
  avatarUrl: string
}

type TaskTag = {
  companyId: number
  isDeleted: boolean
  createdBy: number
  updatedBy: number
  createdAt: string
  updatedAt: string
  id: number
  title: string
  hexadecimalColorCode: string
}

type TaskFile = {
  fileName: string
  type: string
  fileUrl: string
}

const getAllTasksByMemberIdWithTaskResponse = (
  memberId: string
): Response<Task[]> => {
  return axios.get(`/v1/tasks/members/${memberId}`, {})
}
export default getAllTasksByMemberIdWithTaskResponse
